document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('.custom-multi-select-container');
    
    containers.forEach(container => {
        const toggleBtn = container.querySelector('.js-custom-multi-select');
        const dropdown = container.querySelector('.js-custom-multi-dropdown');
        const realSelect = container.querySelector('.js-real-multi-select');
        const selectedText = container.querySelector('.selected-text');
        
        if (!toggleBtn || !dropdown || !realSelect) return;
        
        const defaultPlaceholder = (selectedText && selectedText.textContent.trim()) || 'Select the Services*';
        
        // Toggle dropdown on click
        toggleBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            
            // Close other custom dropdowns first
            document.querySelectorAll('.js-custom-multi-dropdown.open').forEach(otherDropdown => {
                if (otherDropdown !== dropdown) {
                    otherDropdown.classList.remove('open');
                }
            });
            document.querySelectorAll('.js-custom-multi-select.open').forEach(otherBtn => {
                if (otherBtn !== toggleBtn) {
                    otherBtn.classList.remove('open');
                }
            });
            
            dropdown.classList.toggle('open');
            toggleBtn.classList.toggle('open');
        });
        
        // Prevent click inside dropdown from closing it
        dropdown.addEventListener('click', (e) => {
            e.stopPropagation();
        });
        
        // Handle checkbox changes
        const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                const selectedValues = [];
                
                // Clear real select selections
                Array.from(realSelect.options).forEach(opt => opt.selected = false);
                
                checkboxes.forEach(cb => {
                    if (cb.checked) {
                        selectedValues.push(cb.value);
                        // Mark the option in the real select as selected
                        const option = Array.from(realSelect.options).find(opt => opt.value === cb.value);
                        if (option) {
                            option.selected = true;
                        }
                    }
                });
                
                // Update selected text display
                if (selectedText) {
                    if (selectedValues.length > 0) {
                        selectedText.textContent = selectedValues.join(', ');
                        selectedText.style.color = '#fff';
                    } else {
                        selectedText.textContent = defaultPlaceholder;
                        selectedText.style.color = 'rgba(255,255,255,0.7)';
                    }
                }
                
                // Trigger change event on real select
                realSelect.dispatchEvent(new Event('change'));
            });
        });
    });
    
    // Close all dropdowns when clicking outside
    document.addEventListener('click', () => {
        document.querySelectorAll('.js-custom-multi-dropdown.open').forEach(dropdown => {
            dropdown.classList.remove('open');
        });
        document.querySelectorAll('.js-custom-multi-select.open').forEach(btn => {
            btn.classList.remove('open');
        });
    });
});
